export default "__VITE_PUBLIC_ASSET__fe9d56fc__"